import Client from "./_client";

export const getCompaniesWithDetails = async (filters) => {
    let url = "/codeChallenge/filter/company?";
  
    Object.keys(filters).forEach((key) => {
      if (filters[key] !== undefined) url += `${key}=${filters[key]}&`;
    });
  
    const result = await new Client({
      path: url,
    }).get();
  
    if (!(result.ok || result.code === 200)) {
      throw new Error(
        result.message || "Uh Oh! Unable to get comapanies details. Please try again."
      );
    }
    return result?.data;
  }

  export const getSubTopicsWithDetails = async (filters = {}) => {
    let url = "/codeChallenge/filter/subTopic";
  
    const queryParams = Object.keys(filters)
      .filter((key) => filters[key] !== undefined)
      .map((key) => `${key}=${filters[key]}`)
      .join("&");
  
    if (queryParams) {
      url += `?${queryParams}`;
    }
  
    const result = await new Client({ path: url }).get();
  
    if (!(result.ok || result.code === 200)) {
      throw new Error(
        result.message || "Uh Oh! Unable to get subTopic details. Please try again."
      );
    }
  
    return result?.data;
  };

  export const getChallengesByTags = async (filters) => {
    let url = "/codeChallenge/filters?";
  
    Object.keys(filters).forEach((key) => {
      if (filters[key] !== undefined) url += `${key}=${filters[key]}&`;
    });
  
    const result = await new Client({
      path: url,
    }).get();
  
    if (!(result.ok || result.code === 200)) {
      throw new Error(
        result.message || "Uh Oh! Unable to get challenges. Please try again."
      );
    }
    return result?.data;
  }

  export const createChallenge = async (data , challengeId) => {

    let result;

    if(challengeId){
      result = await new Client({
        path : `/userCodeDetail/${challengeId}`,
        payload : data
      }).put();
    }else{
      result = await new Client({
        path: `/userCodeDetail`,
        payload: data
      }).post();
    }
  
    if (!(result.ok || result.code === 200)) {
      throw new Error(
        result.message ||
        "Uh Oh! Unable to create challenge. Please try again."
      );
    } else {
      return result.data;
    }
  };

  export const getCodingInterviews = async (draftFilters = {}) => {
    let url = `/userCodeDetail/mockList?`;
    Object.keys(draftFilters).forEach((key) => {
        if (draftFilters[key]) url += `${key}=${draftFilters[key]}&`;
    });
    const result = await new Client({
        path: url,
    }).get();
    if (!(result.ok || result.code === 200)) {
        throw new Error(
            result.message || "Uh Oh! Unable to get interviews. Please try again."
        );
    }
    return result?.data?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  };

  export const deleteChallenge = async (challengeId) => {

    const result = await new Client({
        path: `/userCodeDetail/${challengeId}`,
    }).delete();

    if (!(result.ok || result.code === 200)) {
        throw new Error(
            result.message || "Uh Oh! Unable to delete challenge. Please try again."
        );
    }

    return result;
};
